"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('alipay', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M24 2C36.1502 2 46 11.8497 46 24C46 36.1503 36.1502 46 24 46C11.8497 46 1.99998 36.1503 1.99998 24C1.99998 11.8497 11.8497 2 24 2ZM24 6C14.0589 6 5.99998 14.0589 5.99998 24C5.99998 33.9411 14.0589 42 24 42C30.1764 42 35.6263 38.8892 38.8682 34.1488C37.5543 33.7598 35.4553 33.0861 32.7422 31.9465C31.6085 31.4703 29.9154 30.7191 27.6628 29.6929C24.9676 32.409 21.0382 35 16.8263 35C13.9034 34.9857 8.99998 33.5084 8.99998 28.9003C8.99998 24.2922 13.5429 23.1956 16.4903 23.1956C18.2741 23.1956 21.4308 24.18 25.9606 26.1489L26.0303 26.1762C27.2462 24.6888 28.0804 22.9615 28.5337 20.994L28.625 20.569L20.6949 20.569C19.4937 20.5689 18.2042 20.5689 16.8263 20.5688V18.4424L22.196 18.442V15.784L14.6781 15.7844V14.1896L22.196 14.189L22.1969 11H26.4933L26.493 14.189L35.0863 14.1896V15.7844L26.493 15.784V18.442L33.3554 18.4424C33.2546 19.1059 33.1412 19.7087 33.0152 20.2508L32.938 20.5688C32.6223 21.7104 31.912 23.3732 30.8073 25.5571C30.514 26.1369 30.0901 26.8074 29.5549 27.5182C31.2453 28.1447 32.9567 28.7524 34.6888 29.3419C36.9312 30.1051 38.8698 30.7227 40.5045 31.1947C41.4664 28.9913 42 26.558 42 24C42 14.0589 33.9411 6 24 6ZM11.4557 28.165C11.4557 31.0967 17.5876 32.2645 22.5558 29.1789C23.1152 28.8315 23.6377 28.4609 24.1235 28.0671L24.1069 28.0595L23.7158 27.8193C20.6157 25.9331 18.2072 24.9104 16.4903 24.7511C14.9151 24.605 11.4557 25.2333 11.4557 28.165ZM28.625 20.5688L28.625 20.569L30.6491 20.5693L28.625 20.5688Z",
    fill: props.outStrokeColor
  }));
});

exports.default = _default;